import { Injectable } from '@angular/core';
import { AbstractDeleteOneService } from 'src/app/modules/core/service/v2/service/delete/abstractDeleteOne.service';
import {TagModel} from "../model/tag.model";
import {TagSummaryModel} from "../model/tagSummary.model";
import {TagSummaryDataServiceAdapter} from "../../impl/service/ngrx/tagSummaryDataService.adapter";
import {TagRepository} from "../../impl/service/ngrx/tag.repository";

@Injectable()
export class TagDeleteService extends AbstractDeleteOneService<TagModel, TagSummaryModel> {

    constructor(repository: TagRepository,
                dataServiceAdapter: TagSummaryDataServiceAdapter) {
        super(repository, dataServiceAdapter);
    }

}
